<section
  class="flex flex-col items-center justify-between space-y-6 text-center text-slate-900 p-8 tablet-sm:p-20 w-fit mx-auto"
  role="alert"
  aria-live="polite"
  *transloco="let t; scope: scope; read: scope"
>
  <!-- Error icon animation -->
  <div class="relative h-32 w-32 flex items-center justify-center">
    <svg
      class="absolute h-32 w-32 animate-error-appear"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="50" cy="50" r="45" fill="#C9272F" />
      <path
        d="M 30 30 L 70 70 M 70 30 L 30 70"
        stroke="white"
        stroke-width="6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>

  <div class="flex flex-col items-center gap-4 justify-center">
    <div class="space-y-4 pt-10 pb-20">
      <p class="text-2xl font-averta-semibold uppercase text-font_error">
        {{ t("error." + getErrorKey() + ".title") }}
      </p>
      <p class="text-base font-calibre-regular text-font_grey_primary max-w-md">
        {{ t("error." + getErrorKey() + ".message", { email: email }) }}
      </p>
    </div>

    <a
      class="bg-yellow w-full px-4 py-2 rounded-md font-averta-semibold hover:bg-opacity-60"
      [routerLink]="'/login'"
      tabindex="0"
      [attr.aria-label]="t('error.button')"
    >
      {{ t("error.button") }}
    </a>
  </div>
</section>
